import { ref, onBeforeMount } from 'vue'

type DeviceType = 'tablet' | 'mobile' | 'desktop'
type ScreenOrientation = 'landscape' | 'portrait'

export function useDeviceDetection () {
  const hasMobileAds = ref(false) // viewport size (< 768) triggers mobile ads (device independent)
  const isTablet = ref(false) // needed for desktopAds switch on tablets
  const viewportWidth = ref<number | null>(null)
  const userAgent = ref('')
  const deviceType = ref<DeviceType | null>(null)
  const screenOrientation = ref<ScreenOrientation | null>(null)

  onBeforeMount(() => {
    viewportWidth.value = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    hasMobileAds.value = viewportWidth.value < 768

    userAgent.value = window.navigator.userAgent.toLowerCase()
    const narrowScreenWidth = window.screen.width < window.screen.height
      ? window.screen.width
      : window.screen.height

    isTablet.value = (
      /android|ipad|playbook|silk/i.test(userAgent.value) ||
        (
          // ontouchend is experimental technology - so we just use it to get rid of safaris default enabled desktop ua on ipads
          /safari/i.test(userAgent.value) &&
          'ontouchend' in document
        )
        // firefox also assigns mobile string to tablet useragent, so we finally check the narrowest screen width
    ) && narrowScreenWidth >= 600 // best smallest analytics value

    deviceType.value = isTablet.value ? 'tablet' : hasMobileAds.value ? 'mobile' : 'desktop'
    screenOrientation.value = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  })

  return { hasMobileAds, isTablet, viewportWidth, userAgent, deviceType, screenOrientation }
}
